import { Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
    selector: '[isEllipsisActive]',
    standalone: false
})
/**
 * If text is shrinked (text-overflow: ellipsis), on mouse hover show tooltip with full text that was shrinked
 */
export class isEllipsisActiveDirective {
  constructor(private readonly elementRef: ElementRef) {}
  isEllipsis = false;
  displayState: string;

  @HostListener('mouseenter')
  onMouseEnter(): void {
    setTimeout(() => {
      const element = this.elementRef.nativeElement;
      let offsetWidth = 0;
      let scrollWidth = 0;
      if (element.offsetWidth == 0) {
        offsetWidth = element.parentElement.offsetWidth;
        scrollWidth = element.parentElement.scrollWidth;
      } else {
        offsetWidth = element.offsetWidth;
        scrollWidth = element.scrollWidth;
      }
      if (offsetWidth < scrollWidth) {
        this.displayState = getComputedStyle(element).display;
        element.style.display = 'block';
        element.style.paddingBottom = '7px';
        element.title = element.textContent;
        this.isEllipsis = true;
      } else if (element.title) {
        element.removeAttribute('title');
      }
    }, 1);
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    if (this.displayState) {
      if (this.elementRef.nativeElement.offsetWidth == 0) {
        this.elementRef.nativeElement.parentElement.style.display = 'inherit';
      } else {
        this.elementRef.nativeElement.style.display = this.displayState;
      }
    }
  }
}
